export default __webpack_public_path__ + "static/media/logo-b-w.0e4bc3d3.svg";